import { useEffect, useState } from "react";
import { formatDateToHour } from "../utils";
import { NOTIFICATION_CODES } from "../constant/index";
import { createEmptyEventInfo } from "../utils/helper";

/**
 * Custom hook to manage event information from notifications
 * @param {Array} nfc - Notification array
 * @param {Object} item - Camera item
 * @param {number} screenTotal - Total screens
 * @returns {Object} - Event info state
 */
export const useEventInfo = (nfc, item, screenTotal) => {
    const [eventInfo, setEventInfo] = useState(createEmptyEventInfo());

    useEffect(() => {
        const event = nfc?.find((n) => n?.code === item?.code);

        if (!event) {
            setEventInfo(createEmptyEventInfo());
            return;
        }

        const baseEvent = {
            ...event,
            time: event?.time ? formatDateToHour(event.time) : "",
            object: event?.object || "",
            info: event?.info || "",
            image: process.env.REACT_APP_FSR_EVENT + event?.image,
            show: true,
        };

        switch (event?.type_notification_code) {
            case NOTIFICATION_CODES.FACE_RECOGNITION:
            case NOTIFICATION_CODES.LICENSE_PLATE_RECOGNITION:
                setEventInfo(baseEvent);
                break;
            default:
                setEventInfo(createEmptyEventInfo());
        }
    }, [nfc, item?.code]);

    // Reset event info when screen total changes
    useEffect(() => {
        setEventInfo(createEmptyEventInfo());
    }, [screenTotal]);

    return eventInfo;
};

